const CardShapesBusiness = () => {
  return (
    <svg
      width='369'
      height='228'
      viewBox='0 0 369 228'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g opacity='0.9' filter='url(#filter0_f_199_4073)'>
        <path
          d='M273.281 151.483L262.044 112.75C261.326 110.273 262.239 107.615 264.329 106.086L316.463 68.0669C318.689 66.4449 321.728 66.4859 323.913 68.1665L374.88 107.497C378.638 110.396 377.831 116.251 373.431 118.043L281.568 155.465C278.164 156.853 274.3 154.997 273.281 151.478V151.483Z'
          fill='url(#paint0_linear_199_4073)'
          fillOpacity='0.4'
        />
      </g>
      <g opacity='0.9' filter='url(#filter1_f_199_4073)'>
        <path
          d='M169.677 89.6411L193.356 107.123C195.435 108.658 196.336 111.324 195.606 113.796L180.303 165.721C179.349 168.967 175.933 170.836 172.663 169.904L124.505 156.195C120.405 155.029 118.691 150.178 121.165 146.716L160.948 91.0238C162.956 88.2116 166.891 87.5906 169.677 89.647V89.6411Z'
          fill='url(#paint1_linear_199_4073)'
          fillOpacity='0.4'
        />
      </g>
      <g opacity='0.9' filter='url(#filter2_f_199_4073)'>
        <path
          d='M223.657 138.069L196.279 158.47C194.457 159.829 193.527 162.077 193.856 164.325L205.575 244H373.221L231.032 138.069C228.844 136.439 225.845 136.439 223.657 138.069Z'
          fill='url(#paint2_linear_199_4073)'
          fillOpacity='0.4'
        />
      </g>
      <g opacity='0.9' filter='url(#filter3_f_199_4073)'>
        <path
          d='M5 -30L153.258 80.3367C154.674 81.3946 156.484 81.7883 158.217 81.4239L201.327 72.2907C203.548 71.8206 205.329 70.1691 205.969 67.9886L234.693 -30H5Z'
          fill='url(#paint3_linear_199_4073)'
          fillOpacity='0.4'
        />
      </g>
      <g opacity='0.9' filter='url(#filter4_f_199_4073)'>
        <path
          d='M311.372 -30L240.115 27.0785C238.15 28.648 237.339 31.252 238.056 33.6561L245.178 57.574C246.095 60.6483 249.217 62.5116 252.358 61.8533L382.137 34.7544V-30H311.372Z'
          fill='url(#paint4_linear_199_4073)'
          fillOpacity='0.4'
        />
      </g>
      <defs>
        <filter
          id='filter0_f_199_4073'
          x='256.802'
          y='61.8777'
          width='125.471'
          height='99.0496'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feGaussianBlur
            stdDeviation='2.5'
            result='effect1_foregroundBlur_199_4073'
          />
        </filter>
        <filter
          id='filter1_f_199_4073'
          x='115.018'
          y='83.4333'
          width='85.8389'
          height='91.7102'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feGaussianBlur
            stdDeviation='2.5'
            result='effect1_foregroundBlur_199_4073'
          />
        </filter>
        <filter
          id='filter2_f_199_4073'
          x='188.791'
          y='131.847'
          width='189.43'
          height='117.153'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feGaussianBlur
            stdDeviation='2.5'
            result='effect1_foregroundBlur_199_4073'
          />
        </filter>
        <filter
          id='filter3_f_199_4073'
          x='0'
          y='-35'
          width='239.693'
          height='121.557'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feGaussianBlur
            stdDeviation='2.5'
            result='effect1_foregroundBlur_199_4073'
          />
        </filter>
        <filter
          id='filter4_f_199_4073'
          x='232.799'
          y='-35'
          width='154.339'
          height='101.985'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feGaussianBlur
            stdDeviation='2.5'
            result='effect1_foregroundBlur_199_4073'
          />
        </filter>
        <linearGradient
          id='paint0_linear_199_4073'
          x1='251.546'
          y1='105.514'
          x2='405.643'
          y2='90.9875'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FC2E2E' />
          <stop offset='1' stopColor='#FF8E8E' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_199_4073'
          x1='113.282'
          y1='123.885'
          x2='214.926'
          y2='117.027'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FC2E2E' />
          <stop offset='1' stopColor='#FF8E8E' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_199_4073'
          x1='177.855'
          y1='183.338'
          x2='415.906'
          y2='154.359'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FC2E2E' />
          <stop offset='1' stopColor='#FF8E8E' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_199_4073'
          x1='-15.4005'
          y1='18.4017'
          x2='287.074'
          y2='-26.8747'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FC2E2E' />
          <stop offset='1' stopColor='#FF8E8E' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_199_4073'
          x1='224.979'
          y1='9.91017'
          x2='416.816'
          y2='-11.9738'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FC2E2E' />
          <stop offset='1' stopColor='#FF8E8E' stopOpacity='0' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CardShapesBusiness;
